import React from 'react';
import { calculateAge } from '../../utils/helpers';
import LivestockIcon from '../common/LivestockIcon';

// Helper component for the sort indicator icon (▲ or ▼)
const SortIndicator = ({ direction }) => {
    if (!direction) return null;
    return direction === 'ascending' ? ' ▲' : ' ▼';
};

// Map statuses to colors for the indicator dot
const statusColorMap = {
    "Milking": "bg-blue-500",
    "Pregnant": "bg-purple-500",
    "Dry (Not Milking)": "bg-yellow-500",
    "Feeding": "bg-green-500",
    "Sold": "bg-gray-400",
    "Dead": "bg-red-500",
};

const LivestockTable = ({ livestock, isLoading, onSelectLivestock, onAddLivestockClick, requestSort, sortConfig, onUpdateStatusClick }) => {
    if (isLoading) return <div className="text-center py-10">Loading livestock data...</div>;

    if (livestock.length === 0) return (
        <div className="text-center py-16 border-2 border-dashed border-gray-300 rounded-lg">
            <LivestockIcon />
            <h3 className="mt-2 text-lg font-medium text-gray-900">No Livestock Found</h3>
            <p className="mt-1 text-sm text-gray-500">Try adjusting your search or filter.</p>
        </div>
    );

    const getSortDirection = (key) => sortConfig && sortConfig.key === key ? sortConfig.direction : undefined;

    return (
        <div className="overflow-x-auto bg-white rounded-lg shadow">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <button onClick={() => requestSort('name')} className="font-bold text-gray-500 hover:text-gray-700 flex items-center">
                                Name <span className="ml-1"><SortIndicator direction={getSortDirection('name')} /></span>
                            </button>
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tag #</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <button onClick={() => requestSort('dateOfBirth')} className="font-bold text-gray-500 hover:text-gray-700 flex items-center">
                                Age <span className="ml-1"><SortIndicator direction={getSortDirection('dateOfBirth')} /></span>
                            </button>
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {livestock.map(animal => (
                        <tr key={animal.id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-indigo-600">
                                <div className="flex items-center">
                                    <span className={`h-3 w-3 rounded-full mr-3 ${statusColorMap[animal.status] || 'bg-gray-200'}`}></span>
                                    <a href="#" onClick={(e) => { e.preventDefault(); onSelectLivestock(animal.id); }} className="hover:underline">{animal.name}</a>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{animal.status || 'N/A'}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{animal.tagNumber}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{calculateAge(animal.dateOfBirth)}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium space-x-4">
                                <button onClick={() => onUpdateStatusClick(animal)} className="text-indigo-600 hover:text-indigo-900">Update Status</button>
                                <a href="#" onClick={(e) => { e.preventDefault(); onSelectLivestock(animal.id); }} className="text-gray-600 hover:text-indigo-900">View Details</a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default LivestockTable;